import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const MAX_SIZE_PX = 900;

function PreviewImageBox({
  resolution, hasImage, invalid, children, maxSizePx,
}) {
  let resolutionContainer = null;
  if (resolution) {
    const { width, height } = resolution;
    resolutionContainer = {
      width, height,
    };

    const validateSizePx = maxSizePx || MAX_SIZE_PX;

    while (resolutionContainer.width > validateSizePx || resolutionContainer.height > validateSizePx) {
      resolutionContainer.width -= ((resolutionContainer.width / 100) * 10);
      resolutionContainer.height -= ((resolutionContainer.height / 100) * 10);
    }
  }

  return (
    <Container
      resolution={resolutionContainer}
      hasImage={hasImage}
      invalid={invalid}
    >
      {children}
    </Container>
  );
}

PreviewImageBox.defaultProps = {
  resolution: null,
  hasImage: false,
  invalid: false,
  maxSizePx: null,
};

PreviewImageBox.propTypes = {
  resolution: PropTypes.shape(),
  hasImage: PropTypes.bool,
  invalid: PropTypes.bool,
  maxSizePx: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PreviewImageBox;
